<div class="field-table-row py-1 {{item.isgroup ? '' : 'field-table-single'}} {{opened ? 'opened' : ''}}" style="--i: {{item.level ? (item.level - 1) : 0}}" (click)="item.isgroup ? opened = !opened : false;">
    <div class="row">
        <div class="col-4 field-table-name d-flex align-items-center" style="--i: {{item.level ? (item.level - 1) : 0}}">
            <i *ngIf="item.isgroup && !opened" class="fas field-table-name-type-icon no-bg fa-angle-down"></i>
            <i *ngIf="item.isgroup && opened" class="fas field-table-name-type-icon no-bg fa-angle-up"></i>
            <i *ngIf="(item.level ? (item.level > 1 || !item.isgroup) : true)" class="{{item.icon || item.typeclass}} field-table-name-type-icon flex-shrink-0"></i>
            <span class="sfl-item-title flex-grow-1">{{(item.title || item.name || item.key) | translate}}</span>
        </div>
        <div class="col-2 field-table-counter field-table-registrations text-center">
            <span *ngIf="item?.registrations?.length" class="badge badge-light" (click)="handleDetail($event, 'registrations')">{{item?.registrations?.length}}</span>
        </div>
        <div class="col-2 field-table-counter field-table-determinants text-center">
            <span class="badge badge-light" (click)="handleDetail($event, 'Applied determinants'); ">{{item?.determinants?.length}}</span>
        </div>
        <div class="col-2 field-table-counter field-table-determinants text-center">
            <span *ngIf="item?.usedInDeterminants?.length" class="badge badge-light" (click)="handleDetail($event, 'Used in determinants'); ">{{item?.usedInDeterminants?.length}}</span>
        </div>
        <div class="col-2 field-table-options"></div>
    </div>
</div> 

<div *ngIf="item.items && item.items.length > 0 && item.isgroup && opened" class="field-table-groups-container">
    <ng-container *ngFor="let it of item.items">
        <field-table *ngIf="!it.isgroup || (it.isgroup && it.items.length > 0)" (showDetails)="forwardDetails($event)" [item]="it" class="field-table-group d-block"></field-table>
    </ng-container>
</div>